export default __webpack_public_path__ + "6a2de09cc39acf268c525b34ead2532c.png";